import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import { CalendarCheck } from 'lucide-react';
import Button from '../../../components/bootstrap/Button';
import Dropdown, {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from '../../../components/bootstrap/Dropdown';
import PaginationButtons from '../../../components/PaginationButton';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { centralApi } from '../../AxiosInstance/CreateInstance';
import useDarkMode from '../../../hooks/useDarkMode';
import dayjs from 'dayjs';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../../components/bootstrap/Modal';
import Label from '../../../components/bootstrap/forms/Label';
import Input from '../../../components/bootstrap/forms/Input';
import NoDataFound from '../../../assets/No-data-found.png';
import { useCallback } from 'react';
import Icon from '../../../components/icon/Icon';
import Tooltips from '../../../components/bootstrap/Tooltips';
import ResumeAnalysisModal from './Modals/ResumeAnalysis';

interface AppliedCandidatesProps {
	setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
	jdTitle: any;
	title: any;
	departmentName: any;
	candidates: any[];
	scheduledStatuses: Record<
		string,
		{
			scheduled: boolean;
			interviewId: string;
		}
	>;
	statusClasses: Record<string, string>;
	canScheduledInterview: boolean;
	// candidateRound: { roundType: string }[];
	canViewResume: boolean;
	currentPage: number;
	setCurrentPage: (page: number) => void;
	perPage: number;
	setPerPage: (n: number) => void;
	totalCandi: number;
	handleShortlist: (item: any) => void;
	handleShortlistModal: (item: any) => void;
	handleResumeModal: (item: any) => void;
	handleRejectModal: () => void;
	setRejectItem: (item: any) => void;
	navigate: (path: string, options?: any) => void;
	toast: any;
	updateCandidateStatus: (candidateId: string, newStatus: string) => void;
	searchQuery: string;
	setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
	handleRescheduleModal: (
		candidate: any,
		interview?: any
	) => void;
}
interface CandidateHistoryItem {
	_id: string;
	stage: string;
	roundType?: string;
	result?: string;
	rejectionReason?: string;
	updatedBy?: { id: string; name: string } | null;
	updatedAt: string;
	name: string;
	date: string;
}
export interface FormDataState {
	firstName: string;
	lastName: string;
	email: string;
	mobileNo: string;
	linkedin: string;
	experience: string;
	resume: File | null;
}
export interface FormReferDataState {
	employeeId: string,
	firstName: string;
	lastName: string;
	email: string;
	mobileNo: string;
	linkedin: string;
	experience: string;
	resume: File | null;
}

const AppliedCandidates: React.FC<AppliedCandidatesProps> = ({
	setRefresh,
	candidates,
	scheduledStatuses,
	statusClasses,
	canScheduledInterview,
	canViewResume,
	currentPage,
	// candidateRound,
	setCurrentPage,
	perPage,
	setPerPage,
	totalCandi,
	handleShortlist,
	handleShortlistModal,
	handleResumeModal,
	handleRejectModal,
	setRejectItem,
	navigate,
	toast,
	updateCandidateStatus,
	jdTitle,
	title,
	searchQuery,
	setSearchQuery,
	departmentName,
	handleRescheduleModal,
}) => {
	const location = useLocation();
	const { candidateId } = location.state || {};
	const [candidateHistories, setCandidateHistories] = useState<
		Record<string, CandidateHistoryItem[]>
	>({});
	const { darkModeStatus, themeStatus } = useDarkMode();
	const bgColor = localStorage.getItem('facit_darkModeStatus');
	const bgClass = bgColor === 'true' ? 'bg-true' : 'bg-false';
	const [isModalOpen, setModalOpen] = useState<boolean>(false);
	const [selectedCandidateId, setSelectedCandidateId] =
		useState('');
	const [resumeAnalysisModal, setResumeAnalysisModal] =
		useState(false);
	const [cancelModal, setCancelModal] = useState(false);
	const [deleteReason, setDeleteReason] = useState('');
	const [selectedInterviewId, setSelectedInterviewId] = useState<string | null>(null);


	const { id } = useParams();
	const [formData, setFormData] = useState<FormDataState>({
		firstName: '',
		lastName: '',
		email: '',
		mobileNo: '',
		linkedin: '',
		experience: '',
		resume: null,
	});
	const [loading, setLoading] = useState(false);

	function capitalizeWords(str: string | undefined): string {
		if (!str) return '';
		return str
			.toLowerCase()
			.split(' ')
			.map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	}
	const isPdfResume = (resumePath?: string) => {
		return resumePath?.toLowerCase().endsWith('.pdf');
	};

	useEffect(() => {
		const fetchAllHistories = async () => {
			if (!candidates || candidates.length === 0) return;

			try {
				const results: Record<string, CandidateHistoryItem[]> = {};

				const responses = await Promise.all(
					candidates.map((c) =>
						centralApi
							.get(
								`/interviewService/stages/candidate-applications/${c.candidate.id}/history`,
							)
							.then((res) => {
								const app = res.data?.applications?.find(
									(a: any) => a.requisitionID === id,
								);

								const stages = app?.stages || [];
								return { id: c.candidate.id, data: stages };
							})
							.catch((err) => {
								// console.error(`Error fetching history for candidate ${c.candidate.id}`, err);
								return { id: c.candidate.id, data: [] };
							}),
					),
				);

				responses.forEach(({ id: candidateFormID, data }) => {
					results[candidateFormID] = data;
				});

				setCandidateHistories(results);
			} catch (err) {
				//   console.error("Error fetching candidate histories", err);
			}
		};

		fetchAllHistories();
	}, [candidates, id]);

	const handleReevaluate = async (item: any, recommendation: string) => {
		try {
			const feedbackId = item.interviewFeedbackId;
			if (!feedbackId) {
				toast.error('Interview feedback ID not found for this candidate');
				return;
			}
			const body = {
				finalRecommendation: recommendation,
				// rejectionReason: null,
			};

			const response = await centralApi.put(
				`/interviewService/interview_service/${feedbackId}/reevaluate`,
				body,
			);

			if (response.data?.status) {
				toast.success(response.data.msg || 'Interview feedback updated successfully');
				setCandidateHistories((prev) => ({
					...prev,
					[item?.candidate?.id]: [
						...(prev[item?.candidate?.id] || []),
						{
							stage: 'shortlisted',
							updatedAt: new Date().toISOString(),
							name: 'Reevaluated',
						},
					],
				}));
				updateCandidateStatus(
					item.candidate.id,
					recommendation === 'reject' ? 'rejected' : 'shortlisted',
				);
			} else {
				toast.error('Failed to reevaluate candidate');
			}
		} catch (error) {
			toast.error('Something went wrong while re-evaluating candidate');
		}
	};

	const canShowScheduleButton = (stages: any[]): boolean => {
		if (!stages || stages.length === 0) return false;

		const validStages = stages.filter((s) => s.date);
		if (validStages.length === 0) return false;
		const sortedStages = [...validStages].sort(
			(a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
		);

		const lastStage = sortedStages[sortedStages.length - 1];

		if (lastStage.roundType === 'HR' && lastStage.stage === 'applied') {
			return false;
		}
		const hrStage = sortedStages.find((s) => s.roundType === 'HR');
		if (hrStage && hrStage.result?.toLowerCase() !== 'selected') return false;

		return ['shortlisted', 'selected'].includes(lastStage.result?.toLowerCase());
	};

	// if (candidates.length === 0) return null;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value, files, type } = e.target as HTMLInputElement;

		if (type === 'file' && files && files.length > 0) {
			const file = files[0];

			const allowedTypes = [
				'application/pdf',
				'application/msword',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			];

			if (!allowedTypes.includes(file.type)) {
				toast.error('Only PDF, DOC, or DOCX files are allowed.');
				return;
			}

			setFormData((prev) => ({ ...prev, [name]: file }));
			return;
		}

		switch (name) {
			case 'firstName': {
				const nameRegex = /^[A-Za-z]*$/;
				if (value && !nameRegex.test(value)) {
					toast.warn('First name can contain only letters (A–Z)');
					return;
				}
				break;
			}

			case 'lastName': {
				const nameRegex = /^[A-Za-z]*$/;
				if (value && !nameRegex.test(value)) {
					toast.warn('Last name can contain only letters (A–Z)');
					return;
				}
				break;
			}

			case 'mobileNo': {
				const mobileValue = value.replace(/\D/g, '');

				if (mobileValue.length > 10) {
					toast.warn('Mobile number must be 10 digits only');
					return;
				}

				setFormData((prev) => ({
					...prev,
					[name]: mobileValue,
				}));
				return;
			}

			case 'experience': {
				// Allow user to backspace or clear input fully
				if (value === '') {
					setFormData((prev) => ({ ...prev, [name]: value }));
					break;
				}

				// Allow letters, numbers, and spaces
				if (!/^[A-Za-z0-9. ]+$/.test(value)) {
					toast.warn('Only letters, numbers, and spaces are allowed');
					return;
				}

				break;
			}

			default:
				break;
		}
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleCancelInterview = async () => {
		if (!selectedInterviewId) {
			toast.error('Interview ID missing');
			return;
		}

		try {
			const response = await centralApi.delete(
				'/interviewService/interview_service/delete',
				{
					data: {
						interviewId: selectedInterviewId,
						deleteReason,
					},
				},
			);

			if (response.data?.status) {
				toast.success(
					response.data?.msg || 'Interview cancelled successfully',
				);
				setRefresh((prev) => !prev);
				setCancelModal(false);
				setDeleteReason('');
				setSelectedInterviewId(null);
			}
		} catch (error: any) {
			// console.log('Cancel API Error:', error);

			toast.error(
				error?.response?.data?.detail ||
				error?.response?.data?.msg ||
				error?.response?.data?.message ||
				'Something went wrong',
			);
		}
	};
	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (loading) return;

		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

		if (!emailRegex.test(formData.email)) {
			toast.warn('Please enter a valid email address');
			return;
		}

		if (formData.mobileNo.length < 10) {
			toast.warn('Mobile number must be 10 digits');
			return;
		}

		const linkedInRegex =
			/^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company|school)\/[A-Za-z0-9_-]+(\/[A-Za-z0-9_-]+)*\/?$/i;

		if (formData.linkedin && !linkedInRegex.test(formData.linkedin.trim())) {
			toast.warn(
				'Please enter a valid LinkedIn URL (e.g. https://www.linkedin.com/in/username)',
			);
			return;
		}

		setLoading(true);

		try {
			const data = new FormData();

			data.append('name', `${formData.firstName} ${formData.lastName}`);
			data.append('email', formData.email);
			data.append('jobRequisitionId', id || '');
			data.append('mobile', formData.mobileNo);
			data.append('linkedin_url', formData.linkedin);
			data.append('experience', formData.experience);

			if (formData.resume) {
				data.append('resume', formData.resume);
			}

			const response = await centralApi.post(
				'/public/candidate_upload/resume',
				data,
				{
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				},
			);

			if (
				response.data?.status === true ||
				response.status === 200 ||
				response.status === 201
			) {
				toast.success('Candidate details added successfully!');

				setRefresh((prev) => !prev);
				setModalOpen(false);

				// Reset only on success
				setFormData({
					firstName: '',
					lastName: '',
					email: '',
					mobileNo: '',
					linkedin: '',
					experience: '',
					resume: null,
				});
			} else {
				toast.error(response.data?.message || 'Failed to upload candidate');
			}
		} catch (error: any) {
			// console.log('ERR', error);

			toast.error(
				error?.response?.data?.detail ||
				error?.response?.data?.msg ||
				'Something went wrong',
			);
		} finally {
			setLoading(false);
		}
	};

	const handleCloseModal = useCallback(() => {
		setModalOpen(false);
		setFormData({
			firstName: '',
			lastName: '',
			email: '',
			mobileNo: '',
			linkedin: '',
			experience: '',
			resume: null,
		});
	}, []);


	return (
		<>
			<Card>
				<CardHeader borderSize={1} size='sm'>
					<CardLabel iconColor='info' className='ms-2'>
						<CardTitle>
							<>
								<CalendarCheck className='me-2 text-info' />
								Candidate Details
							</>
						</CardTitle>
					</CardLabel>
					<Button
						icon='Add'
						color='dark'
						isLight={darkModeStatus}
						className="btn-active-cyan"
						onClick={() => setModalOpen(true)}>
						Add Candidate
					</Button>
				</CardHeader>
				<CardBody className='table-responsive'>
					<CardActions className='mb-3'>
						<input
							type='text'
							placeholder='Search Candidates...'
							value={searchQuery}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
								setCurrentPage(1);
								setSearchQuery(e.target.value);
							}}
							className='form-control me-3 flex-wrap p-3'
						/>
					</CardActions>
					<div className="overflow-x-auto w-full" style={{ minHeight: "300px" }}>
						<table className='table table-modern table-responsive mb-5'>
							<thead>
								<tr>
									<th >Candidate</th>
									<th >Phone</th>
									<th >Email</th>
									<th >Applied At</th>
									<th >Status</th>
									<th className='text-end'>Action</th>
								</tr>
							</thead>
							<tbody>
								{candidates.length === 0 && (
									<tr>
										<td colSpan={6} className='text-center py-4'>
											<div
												className='d-flex pt-5 flex-column w-100 justify-content-center align-items-center'
												style={{ minHeight: '100%', height: '100%' }}>
												<img
													src={NoDataFound}
													alt='No Data'
													width='200px'
													height='200px'
												/>
												<p className='text-muted fs-5 mt-3'>
													No Candidates Applied
												</p>
											</div>
										</td>
									</tr>
								)}

								{candidates.map((item: any) => {
									let statusLabel = '';
									if (scheduledStatuses[item?.candidate?.id]) {
										statusLabel = 'Scheduled';
									} else if (item.status === 'not_shortlisted') {
										statusLabel = 'Reject';
									} else {
										statusLabel = item.status;
									}
									const normalizeStatus = (status: string) =>
										status.toLowerCase().trim().replace(/\s+/g, '_');
									const statusClass =
										statusClasses[normalizeStatus(item.status)] ||
										statusClasses.default;
									const candidateHistory =
										candidateHistories[item?.candidate?.id] || [];
									const roundOrder = ['L1', 'L2', 'HR'];

									const takenRounds = candidateHistory
										.filter(
											(h) =>
												h.result &&
												['completed', 'pending', 'shortlisted'].includes(
													h.result.toLowerCase(),
												),
										)
										.map((h) => h.roundType);
									const isFinalRoundDone = takenRounds.includes('HR');

									const nextRound = roundOrder.find(
										(round) => !takenRounds.includes(round),
									);
									const canShowOfferLetter =
										candidateHistories[item?.candidate?.id]?.some(
											(history) =>
												history.roundType === 'HR' &&
												history.stage === 'shortlisted'
										);
									return (
										<tr key={item?.candidate?.id}>
											<td className='fw-semibold'>
												<div className='d-flex align-items-center gap-3'>

													{/* Referral Icon + Tooltip */}
													{item?.isReferral && (
														<Tooltips
															title={
																<div className='p-2'>
																	<div>
																		<strong>Referred by:</strong>{" "}
																		{item.referrer?.employeeId}
																	</div>
																	<div>
																		<strong>Name:</strong>{" "}
																		{item.referrer?.fName} {item.referrer?.lName}
																	</div>
																</div>
															}
															placement="bottom"
															className={`custom-tooltip ${darkModeStatus ? 'dark-mode' : 'light-mode'
																}`}
														>
															<Icon
																icon="star"
																size="lg"
																className={`text-${darkModeStatus ? 'light' : 'warning'
																	} cursor-pointer`}
															/>
														</Tooltips>
													)}

													{/* Candidate Name */}
													<span>
														{item?.candidate?.name
															? capitalizeWords(item.candidate.name)
															: '-'}
													</span>

												</div>
											</td>

											<td>
												<div>
													{item?.candidate?.phone
														? `+91 ${item.candidate.phone}`
														: '-'}
												</div>

											</td>
											<td>{item?.candidate?.email || '-'}</td>
											<td className='text-nowrap'>
												{dayjs(item?.appliedAt).format('MMM DD, YYYY, hh:mm A')}
											</td>
											<td>
												<Button
													className={`ps-2 pe-2 py-1 text-capitalize ${statusClass}`}
													style={{
														borderRadius: '0.5rem',
														minWidth: '90px',
														textAlign: 'center',
													}}>
													{item.status === 'not_shortlisted'
														? 'rejected'
														: item.status}
												</Button>
											</td>

											<td style={{ textAlign: 'right' }}>
												<Dropdown direction='start'>
													<DropdownToggle hasIcon={false}>
														<Button>...</Button>
													</DropdownToggle>


													<DropdownMenu className='shadow-sm'>
														<DropdownItem>
															<Button
																icon='Analytics'
																className='text-primary'
																onClick={() => {
																	setSelectedCandidateId(item?.id);
																	setResumeAnalysisModal(true);
																}}>
																View Resume Analysis
															</Button>
														</DropdownItem>
														{/* Shortlist */}
														{item.status !== 'shortlisted' &&
															item.status !== 'not_shortlisted' &&
															item.status !== 'scheduled' &&
															item.status !== 'offer sent' &&
															item.status !== 'hold' &&
															item.status !== 'rejected' &&
															item.status !== 'offer save' &&
															item.status !== 'offer rejected' &&
															item.status !== 'offer accepted' && (
																<DropdownItem>
																	<Button
																		onClick={() =>
																			handleShortlist(item)
																		}
																		className='text-success'
																		icon='person'>
																		Shortlist
																	</Button>
																</DropdownItem>
															)}

														{!canShowOfferLetter &&
															(item.status === "shortlisted" || canShowScheduleButton(
																candidateHistories[item?.candidate?.id],
															)) && (
																<DropdownItem>
																	<Button
																		onClick={() =>
																			handleShortlistModal(item)
																		}
																		className='text-primary'
																		icon='CalendarToday'>
																		Schedule Interview
																	</Button>
																</DropdownItem>
															)}
														{item.status === 'scheduled' && (
															<>
																<DropdownItem>
																	<Button
																		onClick={() =>
																			handleRescheduleModal(item)
																		}
																		className='text-warning'
																		icon='Update'
																	>
																		Reschedule Interview
																	</Button>
																</DropdownItem>
																{scheduledStatuses[item.candidate.id]?.interviewId && (
																	<DropdownItem>
																		<Button
																			onClick={() => {
																				setSelectedInterviewId(
																					scheduledStatuses[item.candidate.id].interviewId
																				);
																				setCancelModal(true);
																			}}
																			className="text-danger"
																			icon="Cancel"
																		>
																			Cancel Interview
																		</Button>
																	</DropdownItem>
																)}
															</>
														)}
														{/* View Resume */}
														<DropdownItem>
															{isPdfResume(item.resumePath) ? (
																<Button
																	isDisable={!canViewResume}
																	icon="RemoveRedEye"
																	onClick={() => handleResumeModal(item)}
																	className="text-info">
																	View Resume
																</Button>
															) : (
																<Button
																	tag="a"
																	href={`${centralApi.defaults.baseURL}public/candidateService/candidate_upload/download-resume/${item.id}`}

																	download
																	isDisable={!canViewResume}
																	icon="Download"
																	className="text-primary">
																	Download Resume
																</Button>
															)}
														</DropdownItem>

														{/* Offer Letter */}
														{candidateHistories[item?.candidate?.id]?.some(
															(history) =>
																history.roundType === 'HR' &&
																history.stage === 'shortlisted',
														) &&
															item.status !== 'offer save' && (
																<DropdownItem>
																	<Button
																		onClick={() =>
																			navigate(
																				'/offer-list/offer-generate',
																				{
																					state: {
																						candidateId:
																							item
																								?.candidate
																								?.id,
																						jobRequisitionId:
																							item?.jobRequisitionId,
																						name: item
																							?.candidate
																							?.name,
																						email: item
																							?.candidate
																							?.email,
																					},
																				},
																			)
																		}
																		className='text-warning'
																		icon='Description'>
																		Offer Letter
																	</Button>
																</DropdownItem>
															)}

														{/* Candidate History */}
														<DropdownItem>
															<Button
																onClick={() =>
																	navigate(
																		`/CandidateApplicationHistory/${id}`,
																		{
																			state: {
																				candidateId:
																					item?.candidate?.id,
																			},
																		},
																	)
																}
																className='text-info'
																icon='History'>
																Candidate Application History
															</Button>
														</DropdownItem>
														{/* Hold Flow */}
														{item.status === 'hold' &&
															item.interviewFeedbackId && (
																<>
																	<DropdownItem className='text-success'>
																		<Button
																			onClick={() =>
																				handleReevaluate(
																					item,
																					'strong hire',
																				)
																			}
																			className='text-success'
																			icon='Person'>
																			Shortlist
																		</Button>
																	</DropdownItem>
																	<DropdownItem className='text-danger'>
																		<Button
																			onClick={() =>
																				handleReevaluate(
																					item,
																					'reject',
																				)
																			}
																			className='text-danger'
																			icon='PersonRemove'>
																			Reject
																		</Button>
																	</DropdownItem>
																</>
															)}

														{/* Reject */}
														{item.status !== 'not_shortlisted' &&
															item.status !== 'shortlisted' &&
															item.status !== 'scheduled' &&
															item.status !== 'offer sent' &&
															item.status !== 'hold' &&
															item.status !== 'rejected' &&
															item.status !== 'offer save' &&
															item.status !== 'offer rejected' &&
															item.status !== 'offer accepted' && (
																<DropdownItem className='text-danger'>
																	<Button
																		onClick={() => {
																			handleRejectModal();
																			setRejectItem(item);
																		}}
																		className='text-danger'
																		icon='PersonRemove'>
																		Reject
																	</Button>
																</DropdownItem>
															)}
													</DropdownMenu>
												</Dropdown>
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				</CardBody>
				<PaginationButtons
					label='Candidates List'
					setCurrentPage={setCurrentPage}
					currentPage={currentPage}
					perPage={perPage}
					setPerPage={setPerPage}
					totalCount={totalCandi}
				/>
			</Card>

			<ResumeAnalysisModal
				isOpen={resumeAnalysisModal}
				setIsOpen={setResumeAnalysisModal}
				candidateId={selectedCandidateId}
			/>

			<Modal
				isOpen={isModalOpen}
				setIsOpen={handleCloseModal}
				size='lg'
				isCentered
				titleId='candidateDetailModule'>
				<ModalHeader setIsOpen={handleCloseModal}>
					<h1> </h1>
				</ModalHeader>
				<ModalBody>
					<div className='w-100 mb-4 d-flex justify-content-center align-items-center text-white rounded'>
						<h5 className='fw-bold m-0'>Apply for this Position</h5>
					</div>

					<h5>
						Job Title -{' '}
						<span className='fw-bold text-light job-requirment-font'> {capitalizeWords(title)}</span>
					</h5>
					<form onSubmit={handleSubmit}>
						<div className='mt-4 mb-2'>
							<div className='row g-3'>
								<div className='col-md-6'>
									<label htmlFor='firstName' className='mb-2 fw-semibold'>
										First Name *
									</label>
									<input
										name='firstName'
										id='firstName'
										type='text'
										placeholder='Dev'
										required
										value={formData.firstName}
										onChange={handleChange}
										className='form-control rounded-2 border border-grey bg-dark p-3'
									/>
								</div>

								<div className='col-md-6'>
									<label htmlFor='lastName' className='mb-2 fw-semibold'>
										Last Name *
									</label>
									<input
										name='lastName'
										id='lastName'
										type='text'
										placeholder='Gupta'
										required
										value={formData.lastName}
										onChange={handleChange}
										className='form-control rounded-2 border border-grey bg-dark p-3'
									/>
								</div>

								<div className='col-md-6'>
									<label htmlFor='email' className='mb-2 fw-semibold'>
										Email Address *
									</label>
									<input
										name='email'
										id='email'
										type='email'
										placeholder='abc@xyz.com'
										required
										value={formData.email}
										onChange={handleChange}
										className='form-control rounded-2 border border-grey bg-dark p-3'
									/>
								</div>

								<div className='col-md-6'>
									<label htmlFor='mobileNo' className='mb-2 fw-semibold'>
										Mobile No *
									</label>
									<input
										name='mobileNo'
										id='mobileNo'
										type='text'
										placeholder='Enter 10 digit mobile number'
										required
										value={formData.mobileNo}
										onChange={handleChange}
										className='form-control rounded-2 border border-grey bg-dark p-3'
									/>
								</div>

								<div className='col-md-6'>
									<label htmlFor='linkedin' className='mb-2 fw-semibold'>
										LinkedIn Profile *
									</label>
									<input
										name='linkedin'
										id='linkedin'
										type='url'
										placeholder='https://linkedin.com/in/yourprofile'
										required
										value={formData.linkedin}
										onChange={handleChange}
										className='form-control rounded-2 border border-grey bg-dark p-3'
									/>
								</div>

								<div className='col-md-6'>
									<label htmlFor='experience' className='mb-2 fw-semibold'>
										Experience *
									</label>
									<input
										name='experience'
										id='experience'
										type='text'
										placeholder='e.g., 2 years'
										required
										value={formData.experience}
										onChange={handleChange}
										className='form-control rounded-2 border border-grey bg-dark p-3'
									/>
								</div>

								<div className='d-flex flex-column mt-3'>
									<label htmlFor='resume' className='mb-2 fw-semibold'>
										Resume (Accepted DocType: PDF, DOC, DOCX) *
									</label>
									<input
										type='file'
										id='resume'
										name='resume'
										accept='.pdf,.doc,.docx'
										required
										onChange={handleChange}
										className='form-control'
									/>
								</div>

								<div className='d-flex justify-content-end align-items-center mt-3'>
									<button
										type='submit'
										disabled={loading}
										className='hrms-gradient-btn hrms-btn p-2 rounded '>
										{loading ? 'Submitting' : 'Submit'}
									</button>
								</div>
							</div>
						</div>
					</form>
				</ModalBody>
			</Modal>
			<Modal isOpen={cancelModal} setIsOpen={setCancelModal} isCentered>
				<ModalHeader setIsOpen={setCancelModal}>
					<ModalTitle id='cancel-interview'>Cancel Interview</ModalTitle>
				</ModalHeader>

				<ModalBody>
					<div className="mb-3">
						<span className="form-label">
							Cancel Reason <span className="text-danger">*</span>
						</span>

						<textarea
							className="form-control"
							rows={4}
							placeholder="Enter reason for cancelling interview"
							value={deleteReason}
							onChange={(e) => setDeleteReason(e.target.value)}
						/>
					</div>

					<div className="d-flex justify-content-end gap-2">
						<Button
							color="light"
							onClick={() => {
								setCancelModal(false);
								setDeleteReason('');
							}}
						>
							Close
						</Button>

						<Button
							color="danger"
							isDisable={!deleteReason.trim()}
							onClick={handleCancelInterview}
						>
							Cancel Interview
						</Button>
					</div>
				</ModalBody>
			</Modal>
		</>
	);
};

export default AppliedCandidates;